import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@authentication/auth.service';
import { TipoUsuario } from '@shared/enums/tipoUsuario';

@Component({
  selector: 'app-vigencias-listados-index',
  templateUrl: './vigencias-listados-index.component.html',
  styleUrls: ['./vigencias-listados-index.component.css']
})
export class VigenciasListadosIndexComponent {

  TipoUsuario = TipoUsuario;

  constructor(private router:Router, public authService: AuthService) { }

}
